export const colors = {
  primary: {
    beach: {
      sand: '#F2E6D8',      // Warm sand color
      ocean: '#2D7D9A',     // Deep ocean blue
      sunset: '#FF7B54',    // Warm sunset orange
      palm: '#4CAF50'       // Palm tree green
    },
    ui: {
      person1: '#38BDF8',   // Bright sky blue
      person2: '#34D399'    // Tropical green
    }
  },
  secondary: {
    holiday: '#FF4B6E',     // Festive red
    bridge: '#FFB347',      // Warm orange
    school: '#A78BFA',      // Soft purple
    vacation: '#38BDF8'     // Sky blue
  },
  neutral: {
    50: '#F8FAFC',         // Background
    100: '#F1F5F9',        // Card background
    200: '#E2E8F0',        // Borders
    300: '#CBD5E1',        // Disabled
    600: '#475569',        // Body text
    900: '#0F172A'         // Headings
  }
} 